// src/pages/Workers/Departments/ExportDepartmentsExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../../i18n";

const ExportDepartmentsExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Departments");

  const t = i18n.t.bind(i18n);

  worksheet.columns = [
    { header: t("common.id"), key: "id", width: 10 },
    { header: t("common.departmentName"), key: "name", width: 25 },
    { header: t("common.worker"), key: "workerCount", width: 20 },
    { header: t("common.status"), key: "status", width: 15 },
    { header: t("common.dateTime"), key: "date", width: 25 },
  ];
  // Add rows
  worksheet.addRows(data);

  // Style header row
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // White bold
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" }, // Dark blue
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Export
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Departments_Report_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

export default ExportDepartmentsExcel;
